// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".MuiBreadcrumbs-li {\n  font-size: 1.75rem;\n}\n\n.MuiBreadcrumbs-li a {\n  color: rgba(0,0,0,.6);\n}\n\n.MuiBreadcrumbs-li .active {\n  color: rgba(0,0,0,.87);\n}\n\n", ""]);
// Exports
module.exports = exports;
